import { fireEvent } from '@testing-library/react';
import { UniDriver } from '@wix/unidriver-core';
import { jsdomReactUniDriver } from '@wix/unidriver-jsdom-react';
import { BaseDriver } from '../driver-factory';
import { BaseUniDriver } from '../base-driver';

export interface TestkitArgs {
  wrapper: Element;
  dataHook: string;
}

export type TestkitOutputRegular<T extends BaseDriver> = (data: {
  element: Element | undefined;
  wrapper: Element;
  eventTrigger: typeof fireEvent;
  dataHook: string;
}) => T;

export type TestkitOutputUni<T extends BaseUniDriver> = (
  base: UniDriver,
  body: UniDriver,
  options: { dataHook: string },
) => T;

const getElement = ({ wrapper, dataHook }: TestkitArgs) => {
  return wrapper.querySelector(`[data-hook='${dataHook}']`) as Element;
};

export function testkitFactoryCreator<T extends BaseDriver>(
  driverFactory: TestkitOutputRegular<T>,
) {
  return (testkitArgs: TestkitArgs) =>
    driverFactory({
      element: getElement(testkitArgs),
      wrapper: testkitArgs.wrapper,
      eventTrigger: fireEvent,
      dataHook: testkitArgs.dataHook,
    });
}

export function uniTestkitFactoryCreator<T extends BaseUniDriver>(
  driverFactory: TestkitOutputUni<T>,
) {
  return (testkitArgs: TestkitArgs) => {
    const element = getElement(testkitArgs);
    return driverFactory(
      jsdomReactUniDriver(element),
      jsdomReactUniDriver(document.body),
      { dataHook: testkitArgs.dataHook },
    );
  };
}
